<template>
    <v-card>
        <v-container class="tree">
            <div class="node">Entry</div>
            <ul>
                <schema-hierarchy-node
                    v-for="rootSchemaTreeEntry in schemaTreeEntries"
                    :schema-tree-entry="rootSchemaTreeEntry"
                    :key="rootSchemaTreeEntry.key"
                    @viewThingSchema="viewThingSchema"
                />
            </ul>
        </v-container>
    </v-card>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { buildSchemaTree, SchemaTreeEntry } from "@/lib/schemaUtils";
import SchemaHierarchyNode from "./SchemaHierarchyNode.vue";
import { AbstractSchemaConfig } from "@/services/schemas/manageSchemasAPI";

const { schemaConfig } = defineProps<{
    schemaConfig: AbstractSchemaConfig
}>();

const emit = defineEmits<{
    (e: "viewThingSchema", thingSchemaName: string);
}>()

const schemaTreeEntries = ref<SchemaTreeEntry[]>(buildSchemaTree(schemaConfig.thingSchemas));

function viewThingSchema(name: string) {
    emit("viewThingSchema", name);
}

</script>

<style>
/* https://codepen.io/ross-angus/pen/jwxMjL */
.tree,
.tree ul,
.tree li {
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
}

.tree {
    margin: 0 0 1em;
    text-align: center;
}
.tree,
.tree ul {
    display: table;
}
.tree ul {
    width: 100%;
}
.tree li {
    display: table-cell;
    padding: 0.5em 0;
    vertical-align: top;
}
/*
 * horizontal lines
 */
.tree li:before {
    outline: solid 1px #666;
    content: "";
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
}
.tree li:first-child:before {
    left: 50%;
}
.tree li:last-child:before {
    right: 50%;
}

.tree .node {
    border: solid 0.1em #666;
    border-radius: 0.2em;
    display: inline-block;
    margin: 0 0.2em 0.5em;
    padding: 0.2em 0.5em;
    position: relative;
}

.tree .node:hover {
    cursor: pointer;
}

/* vertical lines */
.tree ul:before,
.tree .node:before {
    outline: solid 1px #666;
    content: "";
    height: 0.5em;
    left: 50%;
    position: absolute;
}
.tree ul:before {
    top: -0.5em;
}
.tree .node:before {
    top: -0.55em;
}

/* The root node doesn't connect upwards */
.tree > li {
    margin-top: 0;
}
.tree > li:before,
.tree > li:after,
.tree > li > .node:before {
    outline: none;
}
</style>
